export default "__VITE_ASSET__CMXeXkCS__"